import { Outlet, Route } from '@tanstack/router'

import { rootRoute } from '../root'

export const casinoRoute = new Route({
  getParentRoute: () => rootRoute,
  path: 'casino',
  component: Outlet,
})
